import React from "react";
import { Image } from "antd";
import { useAppSelector } from "../../../../../../util/hooks";
import icon from "../../../../../../util/assets/icon_login.png";
import { EmpresaModel } from "../../../../../../models/empresa/empresaModel";
import dayjs from "dayjs";
import { RelatorioLancamentoFinanceiroModel } from "../../../../../../models/relatorio/relatorioLancamentoFinanceiroModel";
import { currencyBRL } from "../../../../../../util/dinheiroBRAuxiliar";
import { newFormatPorcentagem } from "../../../../../../util/formats";

dayjs.locale("pt-br");

export const RelatorioPlanoContaHtml = React.forwardRef<HTMLDivElement>((_props, ref) => {
  //estados globais
  const relatorioState = useAppSelector((state) => state.relatorio);
  const empresaState = useAppSelector((state) => state.empresa);

  const somatorio = relatorioState.listLancamentoFinanceiro
    .filter((conta) => ["01", "02", "03"].includes(conta.codigo))
    .reduce(
      (acumulador, conta) => {
        acumulador.valor += conta.valor || 0;
        return acumulador;
      },
      {
        valor: 0,
      }
    );

  return (
    <div ref={ref} className="relatorios-html-format">
      <div className="rel-cabecalho">
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center", marginTop: "24px", marginBottom: "24px", marginLeft: "14px" }}>
          <Image preview={false} height={50} src={icon} />
          <div className={"logoText"}>
            <div className="labelLogoGeral">
              <span>GRUPO</span>
            </div>
            <div className="labelLogoGeral">
              <span>PASCHOAL</span>
            </div>
          </div>
          <div className="rel-titulo" style={{ display: "flex", flexDirection: "column", marginLeft: "24px" }}>
            <h2>
              <strong>Relatório de Lançamento de Plano de Conta</strong>
            </h2>
            <p>{"Empresa: " + empresaState.list.find((a: EmpresaModel) => a.id === relatorioState.buscaLancamentoFinanceiro.idEmpresa)?.apelido}</p>
            <p style={{ marginTop: "-10px" }}>{"Data Inicial: " + dayjs(relatorioState.buscaLancamentoFinanceiro.dataInicio).format("DD/MM/YYYY")}</p>
            <p style={{ marginTop: "-10px" }}>{"Data Final: " + dayjs(relatorioState.buscaLancamentoFinanceiro.dataFim).format("DD/MM/YYYY")}</p>
          </div>
        </div>
      </div>
      <div className="rel-detalhes-composicao">
        <table className="tb-dados">
          <thead>
            <tr className="header-table">
              <th className="ht-left">Descrição</th>
              <th className="ht-right">Valor</th>
              <th className="ht-right">Percentual</th>
              <th className="ht-right">Percentual do Rendimento</th>
            </tr>
          </thead>
          <tbody className="body-table">
            {relatorioState.listLancamentoFinanceiro.map((t: RelatorioLancamentoFinanceiroModel) => {
              return (
                <React.Fragment key={t.id}>
                  <tr>
                    <td className="ht-left">
                      <div style={{ padding: `2px ${(t.nivel - 1) * 10}px` }}>{`${t.codigo} ${t.denominacao}`}</div>
                    </td>
                    <td className="ht-right" style={{ color: t.valor < 0 ? "red" : "inherit" }}>
                      {t.valor && currencyBRL(t.valor)}
                    </td>
                    <td className="ht-right">{t.percentual && newFormatPorcentagem(t.percentual, 4)}</td>
                    <td className="ht-right">{t.percentualReceita && newFormatPorcentagem(t.percentualReceita, 4)}</td>
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
        <div className="footer-table">
          <table className="tb-dados">
            <tbody>
              <tr>
                <td className="ht-left">Total</td>
                <td className="ht-right" style={{ color: somatorio.valor < 0 ? "red" : "inherit" }}>
                  {currencyBRL(somatorio.valor)}
                </td>
                <td className="ht-right"></td>
                <td className="ht-right"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
});
